import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import ModalTriggerPromoPanelComponent from './js/modal-trigger-promo-panel.component';
import ModalTriggerLoginComponent from '../account/js/modal-trigger-login.component';

ComponentsFactory.getInstance().define('modal-trigger-promo-panel', ModalTriggerPromoPanelComponent);
ComponentsFactory.getInstance().define('modal-trigger-login', ModalTriggerLoginComponent);
